import React from 'react';
import type { ShippingAddressData } from '../../../../types';

interface ShippingAddressViewProps {
  shippingAddress: ShippingAddressData;
  isCompleted: boolean;
}

const ShippingAddressView: React.FC<ShippingAddressViewProps> = ({ shippingAddress, isCompleted }) => {
  if (!isCompleted) {
    return <p className="text-red-500">Endereço de entrega ainda não informado.</p>;
  }

  return (
    <div className="space-y-3">
      <div>
        <div className="font-bold">Endereço para entrega:</div>
        <div>{shippingAddress.street}, {shippingAddress.number}<span> - {shippingAddress.neighborhood}</span></div>
        {shippingAddress.complement && <div>{shippingAddress.complement}</div>}
        <span>{shippingAddress.city}, {shippingAddress.state} | CEP {shippingAddress.zipCode}</span>
      </div>
      <div>
        <div className="font-bold">Forma de entrega:</div>
        <span>Grátis</span>
      </div>
    </div>
  );
};

export default ShippingAddressView; 